let lastIsOpen: () => boolean;
let lastChangeOpen: (isOpen: boolean) => void;

export function bindFilterOptionsState(
  isOpen: typeof lastIsOpen,
  changeOpen: typeof lastChangeOpen,
): void {
  lastIsOpen = isOpen;
  lastChangeOpen = changeOpen;
}

export function areFilterOptionsShowing(): boolean {
  return Boolean(lastIsOpen && lastIsOpen());
}

export function hideFilterOptions(): void {
  if (lastChangeOpen) {
    lastChangeOpen(false);
  }
}
